import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import { Route, Routes, useNavigate, Navigate, useLocation } from "react-router-dom";

import MainLayout from "./components/MainLayout";
import AdminLayout from "./components/AdminLayout";
import EinteilungScreen from "./screens/Einteilung";
import AdminProjects from "./screens/AdminProjects";
import AdminUsers from "./screens/AdminUsers";
import KindergartenScreen from "./screens/Kindergarten";
import LoginScreen from "./screens/Login";
import MittelstufeScreen from "./screens/Mittelstufe";
import ProjectsScreen from "./screens/Projects";
import StandorteScreen from "./screens/Standorte";
import KarteScreen from "./screens/Karte";
import QrCodeScreen from "./screens/QrCode";
import FormScreen from "./screens/Form";
import UnterstufeScreen from "./screens/Unterstufe";
import KlassenScreen from "./screens/Klassen";
import SusScreen from "./screens/SuS";
import ProtectedRoute from "./components/ProtectedRoute";

import Loader from "@components/Loader";

import stores from "@stores";
import { hasToken } from "@helpers/token";

const RouteControl = () => {
  const [isAdmin, setIsAdmin] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const {
    sessionStore: { currentUser, getCurrentUser },
  } = stores;

  const isFormRoute = location.pathname.includes('add-student-form');

  useEffect(() => {
    (async () => {
      if (!isFormRoute) {
        if (hasToken()) {
          const userIsAdmin = await getCurrentUser();
          setIsAdmin(userIsAdmin);
        } else {
          navigate('/login');
        }
      }
    })();
  }, [location]);

  if (hasToken() && !currentUser && !isFormRoute) {
    return <Loader filled />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginScreen />} />
      <Route
        path="projekte/:id/standorte"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<StandorteScreen />} />}
          />
        }
      />
      <Route
        path="projekte/:id/karte"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<KarteScreen />} />}
          />
        }
      />
      <Route
        path="projekte/:id/qr-code"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<QrCodeScreen />} />}
          />
        }
      />
      <Route
        path=":type/:id/add-student-form"
        element={
          <FormScreen currentUser={currentUser} />
        }
      />
      <Route
        path="projekte/:id/einteilung"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<EinteilungScreen />} />}
          />
        }
      />
      <Route
        path="projekte/:id/sus"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<SusScreen />} />}
          />
        }
      />
      <Route
        path="projekte/:id/klassen"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<KlassenScreen />} />}
          />
        }
      />
      <Route
        path="/kindergarten"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<KindergartenScreen />} />}
          />
        }
      />
      <Route
        path="/unterstufe"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<UnterstufeScreen />} />}
          />
        }
      />
      <Route
        path="/mittelstufe"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<MittelstufeScreen />} />}
          />
        }
      />
      <Route
        path="/projekte"
        element={
          <ProtectedRoute
            allowed={!!currentUser || hasToken()}
            children={<MainLayout children={<ProjectsScreen />} />}
          />
        }
      />
      <Route
        path="/admin/users"
        element={
          <ProtectedRoute
            allowed={isAdmin}
            children={<AdminLayout children={<AdminUsers />} />}
          />
        }
      />
      <Route
        path="/admin"
        element={
          <ProtectedRoute
            allowed={isAdmin}
            children={<AdminLayout children={<AdminProjects />} />}
          />
        }
      />
      <Route path="/" element={<Navigate replace to="/projekte" />} />
      <Route path="*" element={<div>Not Found</div>} />
    </Routes>
  );
};

export default observer(RouteControl);
